import { AppForm } from '../../../../../../../common/forms/app.form';
import { inject, Injectable, Signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ObrebAppEntityDictionaryObreb,
  ObrebService,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';

export type ArticleItem =
  'Artykuł 93 ustęp 1 i ustęp 2'
  | 'Artykuł 93 ustęp 2a'
  | 'Artykuł 94'
  | 'Artykuł 95 punkt 1-8'
  | 'Inny';

export const divisionOfRealEstateArticle95List: string[] = [
  '1) zniesienia współwłasności nieruchomości zabudowanej co najmniej dwoma budynkami, wzniesionymi na podstawie pozwolenia na budowę, jeżeli podział ma polegać na wydzieleniu dla poszczególnych współwłaścicieli, wskazanych we wspólnym wniosku, budynków wraz z działkami gruntu niezbędnymi do prawidłowego korzystania z tych budynków',
  '2) wydzielenia działki budowlanej, jeżeli budynek został wzniesiony na tej działce przez samoistnego posiadacza w dobrej wierze',
  '3) wydzielenia części nieruchomości, której własność lub użytkowanie wieczyste zostały nabyte z mocy prawa',
  '4) realizacji roszczeń do części nieruchomości, wynikających z przepisów niniejszej ustawy lub z odrębnych ustaw',
  '4a) realizacji przepisów dotyczących przekształcenia prawa użytkowania wieczystego gruntów zabudowanych na cele mieszkaniowe w prawo własności tych gruntów',
  '5) realizacji przepisów dotyczących przekształceń własnościowych albo likwidacji przedsiębiorstw państwowych lub samorządowych',
  '6) wydzielenia części nieruchomości objętej decyzją o ustaleniu lokalizacji drogi publicznej',
  '6a) wydzielenia części nieruchomości objętej decyzją o ustaleniu lokalizacji linii kolejowej',
  '6b) wydzielenia części nieruchomości objętej decyzją o zezwoleniu na realizację inwestycji w zakresie lotniska użytku publicznego w rozumieniu przepisów ustawy z dnia 12 lutego 2009 r. o szczególnych zasadach przygotowania i realizacji inwestycji w zakresie lotnisk użytku publicznego albo decyzją o ustaleniu lokalizacji inwestycji w zakresie CPK w rozumieniu przepisów ustawy z dnia 10 maja 2018 r. o Centralnym Porcie Komunikacyjnym',
  '6c) wydzielenia części nieruchomości objętej decyzją o pozwoleniu na realizację inwestycji w rozumieniu przepisów ustawy z dnia 8 lipca 2010 r. o szczególnych zasadach przygotowania do realizacji inwestycji w zakresie budowli przeciwpowodziowych',
  '6d) wydzielenia części nieruchomości objętej decyzją o ustaleniu lokalizacji inwestycji w rozumieniu przepisów ustawy z dnia 11 sierpnia 2021 r. o przygotowaniu i realizacji inwestycji w zakresie odbudowy Pałacu Saskiego, Pałacu Brühla oraz kamienic przy ulicy Królewskiej w Warszawie (Dz. U. z 2024 r. poz. 578)',
  '6e) wydzielenia części nieruchomości objętej decyzją o zezwoleniu na realizację inwestycji w zakresie budowy strzelnic realizowanych przez uczelnie na podstawie ustawy z dnia 7 lipca 2023 r. o inwestycjach w zakresie budowy strzelnic realizowanych przez uczelnie',
  '7) wydzielenia działki budowlanej niezbędnej do korzystania z budynku mieszkalnego',
  '8) wydzielenia działek gruntu na terenach zamkniętych'
];

@Injectable()
export class OpinionOfConformityOfPropertyDivisionMpzpContentForm extends AppForm {

  private obrebService: ObrebService = inject(ObrebService);

  public divisionOfRealEstateArticle95List: string[] = divisionOfRealEstateArticle95List;

  public obrebList: Signal<ObrebAppEntityDictionaryObreb[] | undefined> = toSignal(this.obrebService.getObrebCollectionObrebCollection({
    pagination: false,
    orderName: 'asc'
  }));

  constructor() {
    super({
      precint: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.maxLength(255)
        ]
      }),
      registrationNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      landRegister: new FormControl(null, [Validators.required, Validators.maxLength(255)]),

      personFullName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),

      article: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),

      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public articleChange(v: ArticleItem): void {
    if (v === 'Artykuł 95 punkt 1-8') {
      this.addControl('divisionOfRealEstateArticle95', new FormControl('', {
        nonNullable: true,
        validators: [Validators.required]
      }));
    } else {
      this.removeControl('divisionOfRealEstateArticle95');
    }
    if (v === 'Inny') {
      this.addControl('otherArticleDescription', new FormControl(null, [Validators.required, Validators.maxLength(5000)]));
    } else {
      this.removeControl('otherArticleDescription');
    }
  }

  public get divisionOfRealEstateArticle95(): FormControl | null {
    return this.get('divisionOfRealEstateArticle95') as FormControl | null;
  }

  public get otherArticleDescription(): FormControl | null {
    return this.get('otherArticleDescription') as FormControl | null;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead) {
    this.articleChange((value?.article || '') as ArticleItem);
    super.patchFormValues(value);
    this.divisionOfRealEstateArticle95?.setValue(value?.otherArticleDescription);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return {
      ...value,
      otherArticleDescription: this.divisionOfRealEstateArticle95?.value || this.otherArticleDescription?.value || null
    };
  }
}
